export const Storage = {
  AVAILABILITY_MODAL_LAST_SHOWN: 'availability_modal_last_shown',
  AGENCY_CITY: 'agencyCity',
  AGENCY_END_DATE: 'agencyEndDate',
  AGENCY_NUM_CHILDREN: 'agencyNumberOfChildren',
  AGENCY_START_DATE: 'agencyStartDate',
  AGENCY_STATE: 'agencyState',
  AGENCY_STREET: 'agencyStreet',
  AGENCY_ZIP: 'agencyZipCode',
  TRUE: 'true',
  SHOW_NUX_SAVED_SEARCH_MODAL: 'showNuxSavedSearchModal',
  SAVED_SEARCH_DATA: 'savedSearchData',
  FACILITY_SHOW_PARENT_PAYWALL: 'facility_show_parent_paywall',
};
